import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailMaterialNotes({ item }) {
    const customMaterial = get(item, 'customMaterial.techniques') || [];

    if (!customMaterial.length) {
        return null;
    }
    return (
        <span data-tn="pdp-spec-material-notes">
            {customMaterial.map(({ id, label }) => <p key={id}>{label}</p>)}
        </span>
    );
}

PdpSharedDetailMaterialNotes.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailMaterialNotes, {
    item: graphql`
        fragment PdpSharedDetailMaterialNotes_item on Item {
            customMaterial {
                techniques {
                    id
                    label
                }
            }
        }
    `,
});
